export default "/shMAGIC.2230c0c7c37d0559e0319e6f985c56b8.svg";